import { render, staticRenderFns } from "./ChatCurrent.vue?vue&type=template&id=349fec38&scoped=true"
import script from "./ChatCurrent.vue?vue&type=script&lang=js"
export * from "./ChatCurrent.vue?vue&type=script&lang=js"
import style0 from "./ChatCurrent.vue?vue&type=style&index=0&id=349fec38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349fec38",
  null
  
)

export default component.exports